export const documentsFilter = {
  name: "documentsFilter",
  criterions: [
    {
      monthToBack: 1,
      fromDataType: 2,
      toDataType: 0,
      value: {
        fromIsSelected: true,
        fromValue: "2021-02-15T00:00:00",
        toIsSelected: false,
        toValue: "2021-02-15T23:59:59.999",
      },
      type: "DateFromToCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 1,
      label: "Okres",
      propertyName: "Period",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          intKey: 0,
          stringKey: "IssueDate",
          stringValue: "Data wystawienia",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "SaleDate",
          stringValue: "Data sprzedaży",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: null,
      booleanExtender: null,
      value: {
        $id: "11",
        intKey: 0,
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 2,
      label: "Okres po",
      propertyName: "PeriodFrom",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 200,
      value: null,
      UniqueId: null,
      type: "AutocompleteTextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 3,
      label: "Kontrahent",
      propertyName: "PropertyName_ContractorsAutocompleteOnlyBuyers",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 140,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 4,
      label: "Nr. dokumentu",
      propertyName: "DocumentNumber",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 140,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          intKey: 0,
          stringKey: "0",
          stringValue: "Wszystkie",
          tooltipValue: "",
        },
        {
          intKey: 2,
          stringKey: "2",
          stringValue: "Do wydruku",
          tooltipValue: "",
        },
        {
          intKey: 3,
          stringKey: "3",
          stringValue: "Wydrukowane",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: null,
      booleanExtender: null,
      value: {
        intKey: 2,
        stringKey: "2",
        stringValue: "Do wydruku",
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 5,
      label: "Status wydruku",
      propertyName: "PrintDocumentStatus",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 200,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          intKey: 0,
          stringKey: "00000000-0000-0000-0000-000000000000",
          stringValue: "Wszyscy",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "44b172fe-b86f-497d-8d76-8e30c02ae0b7",
          stringValue: "abala",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "af82b39d-9374-4c7a-9a17-f1f7303cd3cf",
          stringValue: "abatko",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "6642abcc-572a-4550-a4c3-6d0aa06766db",
          stringValue: "abogusz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "46325108-6a6a-4ac8-ac70-ca470922c8e5",
          stringValue: "aborcz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "8b89525d-699a-488f-8e6c-f523394a4162",
          stringValue: "acaban",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "98bc3268-a633-4add-9380-8ee64b32d1bd",
          stringValue: "acudna",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "fff54670-d8a5-4650-9543-a136c05e33b6",
          stringValue: "admin",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "335c8f3f-4ef4-410c-94a4-9936626b3d9a",
          stringValue: "agizka",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "7c3aab47-e78a-47ad-9d13-5f661c21e1bb",
          stringValue: "ak",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "fd9337aa-1ae8-4374-9c5b-e3aaee4698fb",
          stringValue: "akrupa",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "72905129-6c75-4f77-9e7c-c23d035061e4",
          stringValue: "akrzysiak",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "5ef49b67-fc22-40eb-9e2c-39f0a0211a9c",
          stringValue: "akubala",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "a81cfcd7-1fae-4f95-a066-f06a8d363a0d",
          stringValue: "akulik",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "b7939aba-1eb1-49c8-9ecd-2babbfa4caa6",
          stringValue: "aniestrzeba",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "5975362e-a176-42b0-95e7-64a2a1786a6d",
          stringValue: "anowak",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "b76a4133-0912-46cc-9d0c-5833a9e0dd1e",
          stringValue: "aparadowska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "1c0069cb-1ffd-416e-aee0-29bc6e23c290",
          stringValue: "apawlik",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "91de27dd-95ef-474a-bd6f-62f8d63f64c0",
          stringValue: "apszczola",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "91b5393e-ae1c-40ba-abcc-9927b672d85a",
          stringValue: "asiaradz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "b71120a5-acf8-41c0-90f6-9937d6e81c01",
          stringValue: "ASIERZEGA",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "50c3ba3e-9bfd-40f6-a0cd-3f37f19130da",
          stringValue: "atybuszewska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "8970aa9c-406b-49ef-ab45-0f635c4006d5",
          stringValue: "AutoInvoice",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "0751a92c-dadd-4e83-87c4-3b9a53e3a9a3",
          stringValue: "avirstyuk",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "2a3db0b5-8849-4daf-9eef-d7f4cb35c9e2",
          stringValue: "awacha",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "a02bfefe-d7dd-483b-b62e-d01db8a39c60",
          stringValue: "awojcik",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "503442da-c4e0-4b5f-956e-01555d6bdb6c",
          stringValue: "B2B_Integration",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "ea97f9a1-7a1a-4520-8ca6-8b096160fc33",
          stringValue: "bbak",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "f25adb3f-7765-4271-a939-bc291273300c",
          stringValue: "bbaranska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "5add6693-6bb5-4c1e-9b6a-35d873b68748",
          stringValue: "bbasztura",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "9b64284e-2789-4edc-a840-dd90b953bbc7",
          stringValue: "BC-admin",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "9de8f0d0-2d7e-4aa6-90ae-b0fe0cfa3f8e",
          stringValue: "bkolcz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "79a5539a-8959-4d04-96c8-1601a1f016e1",
          stringValue: "bligeza",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "375e763d-3d2c-4517-b487-8d7997da12d1",
          stringValue: "bmalec",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "900dcaa2-355e-4543-9b41-512915be2d69",
          stringValue: "bmical",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "b345239a-2f0b-4b85-80c7-81500f912dfb",
          stringValue: "bnowak",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "90b0c0ab-2195-4ca2-8544-7b4db91ff618",
          stringValue: "BookingService_WNU",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "f5100167-66cb-4ae8-a7bf-607bf7f5df35",
          stringValue: "bsienko",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "9d7bf4e6-5064-411e-a704-254bfe0c39a8",
          stringValue: "bszczepanska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "680fce08-a014-470c-883e-debc79c731f5",
          stringValue: "CRMIntegration",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "2976c682-6da5-45e9-9048-e79301ebdb5a",
          stringValue: "CronManagerUser",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "600ae9f6-e0fc-493b-a95a-735ac52cabbe",
          stringValue: "cst",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "8f06dbe9-0cfc-4cce-9113-b11422b3d3b6",
          stringValue: "dchrenkoff",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "f3de1c15-8ad5-48cb-9be7-a4b82f9d1365",
          stringValue: "dgudzio",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "7a36362a-7851-4dfb-876c-031e8afcde90",
          stringValue: "dpetryk",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "79fc6f3b-b872-4899-8b09-391a8f929679",
          stringValue: "Drukarka",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "6ff6ae64-33d3-416b-b209-91d00a862e92",
          stringValue: "Drukarka_Krakow",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "eb5265b7-e457-484f-b6cf-d8bd517a2754",
          stringValue: "Drukarka_Krosno",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "f24194eb-0181-4d29-aaf2-5ce1d1fef954",
          stringValue: "Drukarka_Lublin",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "341844cd-f865-4a31-b226-b96abd98d047",
          stringValue: "Drukarka_RZE2",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "630381f4-f690-4944-b327-d055bb7ce386",
          stringValue: "Drukarka_Rzeszow",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "cf3495d4-1326-4bca-b7fe-1056451e4231",
          stringValue: "Drukarka_Warszawa",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "7352c5dc-f664-4622-8f25-9328e3d764da",
          stringValue: "Drukarka_Warszawa_Jasna",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "4c26074d-ce02-4369-97a7-6b0f6780d211",
          stringValue: "dwrobel",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "7ef5ac20-2709-4ae9-a2ed-36f41f058608",
          stringValue: "dzajac",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "b8b922d5-fdba-40b1-8a3c-7c85d880bfee",
          stringValue: "dzaloga",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "6201679d-23f2-4115-959f-18e3ccfc4bde",
          stringValue: "ebednarek",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "35b9b3c3-5ca9-452c-b888-c756159f85ff",
          stringValue: "echamerska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "8dfadc19-a395-4951-8259-1263e0434f80",
          stringValue: "echrzan",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "69f4d697-fb2b-4693-bc31-46760f068964",
          stringValue: "edomaradzka",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "fc2fe302-f11c-4bf7-b360-d82b22dafeac",
          stringValue: "ekrzakiewicz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "6ca459cb-cc15-458d-98c2-0ce9430f5599",
          stringValue: "EksportUser",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "8eefb88c-e108-453d-b366-c8ddedc27b34",
          stringValue: "eliszcz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "3b5ee31f-e485-4ceb-a979-2325c8c11186",
          stringValue: "emadejczyk",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "0c56942c-70b6-40cc-bf59-aceb55285a5c",
          stringValue: "Emergency",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "5df3f13d-2605-4b93-9f9c-22182379c083",
          stringValue: "esobczyk",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "fd50bba9-9d28-4c6c-8acb-aec98e6d60a4",
          stringValue: "ezbieg",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "2a8cfea8-99dc-4eae-97fa-e8ea0d459c2f",
          stringValue: "fnalecz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "eb16cc45-187a-44a9-9fca-62805c5b5be2",
          stringValue: "grupaHotele",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "035becac-e1dd-4d0e-a016-32d6ebab5291",
          stringValue: "grupaLogistyka",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "90effd27-9f3c-47d2-b289-19520e71b07b",
          stringValue: "ibienkowska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "f0b45cc5-e95e-4be5-ab49-ab74665db47c",
          stringValue: "igoreczna",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "a1318bd8-3947-4eb3-9e17-3063e1189738",
          stringValue: "ikorzystka",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "f4a6f2e4-2e24-4b41-b858-e30cb9b42433",
          stringValue: "imagrys",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "39e9aa8c-ecd4-4881-90e6-efeee4b86a9d",
          stringValue: "imaleszka",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "03de0032-f1ca-4348-96c2-9eebdf8ee264",
          stringValue: "imatuszczak",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "1196f6fe-bba5-4285-ab74-9518ae0ebcc1",
          stringValue: "impuls",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "28163e71-8a64-442b-8b95-47e51e11792b",
          stringValue: "integracjaB2B1",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "f6b581c4-0983-4657-a753-7ba4cafc522e",
          stringValue: "iturowska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "54220046-1c91-4212-a959-5c6bbe25f22c",
          stringValue: "jdec",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "e5affc07-6011-486d-b36a-0a416d234d74",
          stringValue: "jkot",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "24f615f8-5cc0-459a-9e9c-32469632527b",
          stringValue: "jmierzwa",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "6a8cb67a-479e-4a06-af04-dcd013830863",
          stringValue: "jnestorowicz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "8fd2bde3-0580-4656-8a16-aa899d4097f0",
          stringValue: "Joanna Dec",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "53adb07d-d8ab-4d7b-bead-25f3957504e8",
          stringValue: "jrymarowicz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "4d45b091-ec10-4434-8c28-cca731fa341f",
          stringValue: "jszpiech",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "edb2b27b-6acb-4a70-bd39-026d1825578b",
          stringValue: "jszura",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "2992f94b-d5e8-494e-ac1c-607be5eb9b95",
          stringValue: "jwiech",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "c6d34963-a71f-4d32-94ab-19134e60777f",
          stringValue: "kasjerzyKielnarowa",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "538f77e0-f353-476d-802e-431c5099d16a",
          stringValue: "kasjerzyKraków",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "bc134c41-a63c-48a8-9414-33f7ff921d23",
          stringValue: "kasjerzyKrosno",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "bda102d6-b440-4925-91ef-87f7e5507b7e",
          stringValue: "kasjerzyRzeszów",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "fc7194f9-a600-4657-b545-9b2e425ff2f5",
          stringValue: "kasjerzyWarszawa",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "213697e2-86ed-4006-9b29-bc7d54d77ee1",
          stringValue: "kchajdys",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "f6c19f8f-6565-4259-b285-32c44e7c6711",
          stringValue: "kdudek",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "6f9f3d55-525c-4848-9877-fc89fb411596",
          stringValue: "kfurtek",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "5ffb3eeb-7b23-4231-8caf-43476320efc9",
          stringValue: "kg",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "8ad1f33c-f357-4ce3-bb3a-ad3b5fb9ce8d",
          stringValue: "kgora",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "4b86d323-0f6b-4b31-b233-d85e04cb451f",
          stringValue: "kjarosz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "7d1f1e9f-b888-43be-a95f-0389bcac55ee",
          stringValue: "kkowalska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "b5d967c9-2bf5-402a-b64b-c14400efaf68",
          stringValue: "klutomska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "42d1e399-d811-4b7f-bdb8-c7080cd155af",
          stringValue: "kmigala",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "3aca7f9e-eaf1-444a-b618-5b9bc816eab1",
          stringValue: "KMU",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "687d7163-85a9-40a7-85a4-86175bd4b5d0",
          stringValue: "kmurias",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "a28fef48-e81d-4bbf-8eaf-242518f2bc20",
          stringValue: "korzechowski",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "b85900aa-a514-4d0e-8e02-e8caa959c1e5",
          stringValue: "kpadwinska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "075063e2-bb69-4ae7-9cf1-c76260451934",
          stringValue: "kstec",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "2308ae86-5112-40e2-b4bc-581b8ba91add",
          stringValue: "kszela",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "de850999-6ab8-459b-8423-24b8e833d785",
          stringValue: "kszlachcic",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "a9f5a617-da2d-40df-9d16-598edb12d78b",
          stringValue: "ktarczynski",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "cef0f5ae-9526-487c-90d4-71a7956c2215",
          stringValue: "kzdunek",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "4871afe7-30f1-4736-8ca5-78198c9d5e63",
          stringValue: "kzurylo",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "e9bd2dc7-63ca-4897-8206-8976279a9ba9",
          stringValue: "lchrabaszcz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "a60f093e-313e-4cc5-b530-e8ea856cd0d6",
          stringValue: "lhasman",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "84684ef6-9c0a-4f08-b818-e339d21d9be2",
          stringValue: "lmalinowski",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "6e2805f2-24ec-4da9-adab-f746dcd03063",
          stringValue: "lr",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "274dd604-f736-483b-bf5b-9a9fcb8534ed",
          stringValue: "lreizer",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "6072d51d-02b4-4940-933f-01f6955dcd2b",
          stringValue: "lsocha",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "4d43ef20-e999-4441-a60d-292b26465247",
          stringValue: "lsokolowski",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "a7f23506-1b51-4edb-8ccc-23aa3369d8cd",
          stringValue: "lzurawska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "da2552fd-6b1a-4d92-8829-9e3e40b22c72",
          stringValue: "mbinko",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "dd64d161-1550-4917-8e02-a0182115f79e",
          stringValue: "mchomiuk",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "97b5ea2c-0364-4fbd-8491-1e60ca520bc6",
          stringValue: "mdyrcz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "6656a3c7-2ac0-4408-b505-c232c8cbd912",
          stringValue: "mj",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "9fcc0152-46aa-4ad2-b940-ba7e8b837d2c",
          stringValue: "mkedzierska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "ce03cee0-323e-41c9-870e-63fd501758c4",
          stringValue: "mkomur",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "dfff5a8a-bff8-4e97-9b46-5a0d368917c7",
          stringValue: "mkurdziel",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "84443f59-b20a-4d93-bbd8-ede20fd03dba",
          stringValue: "mkuzniar",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "a2a4df2d-291a-4cfc-8b98-e3f85d5719ce",
          stringValue: "mlachtara",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "dd17a258-931c-4985-9189-3ecf7dec5d46",
          stringValue: "mlorenc",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "240accc4-a8a0-41f2-b35f-0178217aee5f",
          stringValue: "mmachnicka",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "42351e85-601e-4ac0-8e6f-02eece3178c5",
          stringValue: "mmartyniuk",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "40d532db-fbe5-4682-aed7-f47146f7ef2b",
          stringValue: "mnasternak",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "36594d5c-0722-4df8-97c2-ef698d576116",
          stringValue: "mnuckowska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "1ad953ef-d642-4357-a344-2a0564ee9e43",
          stringValue: "mpiszel",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "0fe8a727-6e3d-4ec4-a10d-1c7074113c1b",
          stringValue: "mpreis",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "df3ee048-1ccd-46cb-9726-f21cae402395",
          stringValue: "mptak",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "34056895-90e5-4ea0-b495-1c0bcc9e11cb",
          stringValue: "mswiatek",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "0f290f2a-daab-4178-9819-095e17588fbb",
          stringValue: "mszczudlik",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "8aea5f59-2779-485b-957a-395b8afc3468",
          stringValue: "mszewczyk",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "622e476d-fc15-4845-a260-9fd1a6e90620",
          stringValue: "mszybiak",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "23ebf09c-f895-4908-a623-8755a9903c2d",
          stringValue: "mtrojanowska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "b3c8d296-ec10-4bcd-99b4-a922e438c60c",
          stringValue: "mwandas",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "2f8c89d7-fc0d-491e-a0cb-a90bec6787c4",
          stringValue: "mwiniecka",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "9db33240-108d-44de-aaf7-cde87d6736a9",
          stringValue: "mziomek",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "5461386c-265b-412d-b9da-e80ac4157e7a",
          stringValue: "NIE PODLEGA",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "4eab3ca3-4cd2-4bba-b046-319e0c40a197",
          stringValue: "NON IATA",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "ae63c10f-a7de-4c21-b2fb-54116f3126f9",
          stringValue: "pbalawender",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "71e39e66-10ee-4ead-b448-4958d740687a",
          stringValue: "pjarosz",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "3ff2b195-209c-41b4-8c4a-fba5f4d923fa",
          stringValue: "pkijowski",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "732e1119-85cf-4509-b70c-9c4f9021b1db",
          stringValue: "Planeta",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "2adce796-8e3f-4a5f-b6c0-7e4ce5090f7c",
          stringValue: "pmazgaj",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "287d78ea-29f1-41bd-a994-d96aed48f495",
          stringValue: "ppreneta",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "74bc92b7-528e-45b6-b172-e1b1daaeb6c8",
          stringValue: "praktykant",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "13289d2d-9920-4441-af13-c6a91ed6d539",
          stringValue: "praktykant02",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "e29be333-e22d-47e8-b101-a3aeeb419c7c",
          stringValue: "praktykant03",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "27e6dd26-b65c-4fc5-987f-8e2a77b3844e",
          stringValue: "praktykant04",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "6cd3d9dc-f1cc-4271-a4e1-c20711688458",
          stringValue: "praktykant05",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "d70470d7-9df6-450c-972c-08ae615a7492",
          stringValue: "praktykant06",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "a78a8fbf-56b5-4468-8a02-d655c0a8b10c",
          stringValue: "praktykant07",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "59b16f12-499e-4b68-a123-3f2b41feb08e",
          stringValue: "praktykant08",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "bf0552a6-0a8d-48bf-b04d-3b1c56d2c416",
          stringValue: "praktykant09",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "0d716689-d4e2-48c5-9297-0a044505ce66",
          stringValue: "pryczkowska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "60629ffd-a99d-4d5a-9fb9-4cf43b363545",
          stringValue: "ptomczyk",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "6f9f3be0-8f9f-4741-a010-baf657ff818b",
          stringValue: "ptrentowski",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "dc459420-8b24-4b1b-b2cc-64593cfd62b1",
          stringValue: "pwoloszyn",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "cfd72832-2eaa-4dff-b00a-59a2fbe3da2c",
          stringValue: "rkuzniar",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "ed8b4705-dfe4-4e9f-b21b-f8b1b6a35f27",
          stringValue: "rmacielag",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "e955db9d-14c9-4f83-b52a-dae6562c6d52",
          stringValue: "rmigala",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "ee9084be-7166-4d3d-961b-922579350a68",
          stringValue: "rtokarska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "a7ce64b5-d709-44fe-a0a6-4ca28eb6861d",
          stringValue: "sgoras",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "43ac6600-bd52-4241-99cc-0a167c88f91b",
          stringValue: "sjanas",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "cf055e46-1f06-49f8-b854-ebf3dc07945b",
          stringValue: "sklosowska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "af82bcd8-c210-43fb-bb0a-175633b4740f",
          stringValue: "smarczydlo",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "4257f2e6-8674-476c-91b8-ad7c0f0d7ce1",
          stringValue: "solvsoft",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "1b2a9090-df16-445a-b65a-7260184c96bf",
          stringValue: "szurek",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "144b3dc9-9db4-4749-99f6-a8addedb1518",
          stringValue: "test_dostepnosci",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "8102dc67-3c1c-4af1-9f3d-8d6bfd6ee86a",
          stringValue: "tester",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "df264e45-5aab-4090-87d2-31d83003fc52",
          stringValue: "tgalezowski",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "84b96e17-3024-4a53-af08-679150d38087",
          stringValue: "tgudzio",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "e7be2c82-6f4a-453a-95d3-3ed1b9c55bdf",
          stringValue: "tripnet-b2b",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "19355018-fa2a-4dd5-8aef-54f6788d20db",
          stringValue: "tszybiak",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "f96e27cb-265b-4a0a-8ce2-50a9c00d8df5",
          stringValue: "wchochorowska",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "03034613-eee2-4c0a-bf08-73b0f1d794ff",
          stringValue: "wkucharczyk",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "1945eed0-9461-4acb-b17c-2509aa7ebd97",
          stringValue: "WNU4a",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "97435181-aec0-4f09-b865-fca07a364fbf",
          stringValue: "wpaszko",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "905d7db0-bc76-4097-bd1e-b1ec79ba4b2a",
          stringValue: "zjedrych",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        intKey: 0,
        stringKey: "00000000-0000-0000-0000-000000000000",
        stringValue: "Wszyscy",
        tooltipValue: "",
      },
      booleanExtender: null,
      value: {
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 6,
      label: "Kasjer",
      propertyName: "Users",
      canDelete: false,
      isRequired: true,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 7,
      label: "Szukaj w poz. dokumentu",
      propertyName: "DocumentItemSearch",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          intKey: 0,
          stringKey: null,
          stringValue: "Wszyscy",
          tooltipValue: "",
        },
        {
          intKey: 3,
          stringKey: null,
          stringValue: "WNU Rzeszów",
          tooltipValue: "",
        },
        {
          intKey: 5,
          stringKey: null,
          stringValue: "WNU Warszawa",
          tooltipValue: "",
        },
        {
          intKey: 6,
          stringKey: null,
          stringValue: "WNU Kraków",
          tooltipValue: "",
        },
        {
          intKey: 7,
          stringKey: null,
          stringValue: "WNU Lublin",
          tooltipValue: "",
        },
        {
          intKey: 8,
          stringKey: null,
          stringValue: "WNU Krosno",
          tooltipValue: "",
        },
        {
          intKey: 14,
          stringKey: null,
          stringValue: "WNU RZE2",
          tooltipValue: "",
        },
        {
          intKey: 19,
          stringKey: null,
          stringValue: "WNU Kongres",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        stringKey: null,
        stringValue: "Wszyscy",
        tooltipValue: "",
      },
      booleanExtender: null,
      value: {
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 8,
      label: "Oddział",
      propertyName: "Department",
      canDelete: false,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
    {
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          stringKey: "ALL",
          stringValue: "Wszystkie",
          tooltipValue: "",
        },
        {
          stringKey: "PLN",
          stringValue: "PLN",
          tooltipValue: "",
        },
        {
          intKey: 0,
          stringKey: "EUR",
          stringValue: "EUR",
          tooltipValue: "",
        },
        {
          stringKey: "NOK",
          stringValue: "NOK",
          tooltipValue: "",
        },
        {
          stringKey: "USD",
          stringValue: "USD",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: {
        stringKey: "ALL",
        stringValue: "Wszystkie",
        tooltipValue: "",
      },
      booleanExtender: null,
      value: {
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 9,
      label: "Waluta dokumentu",
      propertyName: "Currency",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
    {
      extension: null,
      width: 150,
      enumCriterionType: 0,
      enumCriterionItems: [
        {
          stringKey: "All",
          stringValue: "Wszystkie",
          tooltipValue: "",
        },
        {
          stringKey: "NewEmail",
          stringValue: "Do akceptacji",
          tooltipValue: "",
        },
        {
          stringKey: "WaitingToSendWithLink",
          stringValue: "Zaakceptowane z linkiem",
          tooltipValue: "",
        },
        {
          stringKey: "WaitingToSendWithAttachment",
          stringValue: "Zaakceptowane z załącznikiem",
          tooltipValue: "",
        },
        {
          stringKey: "SentWithLink",
          stringValue: "Wysłane z linkiem",
          tooltipValue: "",
        },
        {
          stringKey: "SentWithAttachment",
          stringValue: "Wysłane z załącznikiem",
          tooltipValue: "",
        },
        {
          stringKey: "Open",
          stringValue: "Odczytane",
          tooltipValue: "",
        },
        {
          stringKey: "Cancelled",
          stringValue: "Anulowane",
          tooltipValue: "",
        },
        {
          stringKey: "Error",
          stringValue: "Błąd wysyłania",
          tooltipValue: "",
        },
      ],
      selectedEnumCriterion: null,
      booleanExtender: null,
      value: {
        stringKey: null,
        stringValue: null,
      },
      type: "EnumCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 10,
      label: "Status wysyłki",
      propertyName: "StateToSendDocument",
      canDelete: true,
      isRequired: false,
      isVisible: false,
      tooltip: "",
    },
  ],
};
